import React, { useState } from "react";
import { Trans } from "react-i18next";
import EasyPayPlanTermsAndConditions from "../TermsAndConditions/TermsAndConditions";
import EasyPayPlanGetStartedButton from "../GetStarted/GetStartedButton";
import EasyPayPlanSkipNow from "../SkipNow/SkipNow";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { addUserActivityLogRequest } from "../../../../../../store/brotherPlus/AddUserActivityLogService/addUserActivityLogServiceSlice";
import { EnrollmentRegisterServiceInit } from "../../../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import sparkleIcon from "../../../../../../assets/images/BrotherPlus/sparkles.svg";
import easyPayPlanBanner from "../../../../../../assets/images/BrotherPlus/brother_plus_easy_pay_banner_image.png";
import EcoProButton from "../../../../../shared/button/button";
import BPlusBenefitPoints from "../../BPlusBenefitPoints/BPlusBenefitPoints";

const EasyPayPlanContent = (props) => {
    const { 
        onClose, 
        onSkipService, 
        showSkip = true, 
        showGetStartedBtn = true, 
        showTermsAndConditions = true,
        showGetStartedBtnLandingPage = false, // btn for landing and web plans page
        handleGetStartedLandingPage, // callback to handle B+ service from landing and web plans page,
        handleGetStartedAsBottomWidget = null // callback to handle B+ service from Dashboard page,
    } = props;
    const { t } = useTranslation(["translation"]);
    const dispatch = useDispatch();
    const [isTermsAndconditionsAgreed, setTermsAndConditionAgreed] = useState(false);
  
    const handleTermsAndConditions = (value) => {
        setTermsAndConditionAgreed(value);
    }

    const handleGetStartedBrotherPlus = () => {
        if(handleGetStartedAsBottomWidget){
            handleGetStartedAsBottomWidget();
        }
        dispatch(addUserActivityLogRequest());
        dispatch(EnrollmentRegisterServiceInit({enrollmentFor: 'ECOPRO_USER'}));
    };
    const handleSkipNow = () => {
        onSkipService(true);
        onClose();
    }
    return(
        <div className="easy-pay-plan-content-wrapper">
            <div className="content body-medium">
                <div className="title-wrapper body-large">
                    <img src={sparkleIcon} alt="sparkle-icon" title="sparkle"/>
                    <h1>{t("BROTHER_PLUS.EASY_PAY_BANNER.EASY_PAY_TITLE_NEW")}</h1>
                </div>
                <div className="intro-text">
                    {<Trans i18nKey="BROTHER_PLUS.EASY_PAY_BANNER.EASY_PAY_INFO">
                        Become a member and get benefits when you want. <span className='easy-pay-discount'>Get 5% DISCOUNT off any purchase from B+ stores</span> when
                    </Trans>}
                </div>
                <BPlusBenefitPoints cname="brother-plus-service-promotion-points, bplus-service-points-tick-icon"/>
                {
                    (showTermsAndConditions)
                    ? <EasyPayPlanTermsAndConditions isTermsAndconditionschecked = {handleTermsAndConditions}/>
                    : null
                }
                { 
                    (showGetStartedBtn) 
                    ? <EasyPayPlanGetStartedButton 
                        isTermsAndconditionsAgreed = {isTermsAndconditionsAgreed}
                        handleGetStartedBrotherPlus = {handleGetStartedBrotherPlus}
                    />
                    : null
                }
                {
                    (showGetStartedBtnLandingPage)
                    ?   <div className="button-wrapper">
                            <EcoProButton cname="easy-pay-avail-button body-small" onBtnClick={handleGetStartedLandingPage}>
                                {t("BROTHER_PLUS.EASY_PAY_BANNER.AVAIL_DISCOUNT")}
                            </EcoProButton>
                        </div>
                    : null
                }
                {
                    (showSkip)
                    ? <EasyPayPlanSkipNow handleSkipNow = {handleSkipNow}/>
                    : null
                }
            </div>
            <div class='image-wrapper'>
                <img src={easyPayPlanBanner} alt="easy-pay-banner" title="easy-pay-banner"/>
            </div>
        </div>
    )
};

export default EasyPayPlanContent;